import { ResponsesConnectionError } from '@consta/gpn-responses/ResponsesConnectionError'
import type { Props as ButtonProps } from '@consta/uikit/Button'
import { Button } from '@consta/uikit/Button'
import { getAllProjects, useAppDispatch } from '@core/core/store'

const buttonProps: ButtonProps = {
  width: 'default',
  view: 'ghost',
}

export const ErrorLoadingProjectsPlaceholder = () => {
  const dispatch = useAppDispatch()

  const updateProjects = () => {
    dispatch(getAllProjects())
  }

  return (
    <ResponsesConnectionError
      title="Не удалось загрузить проекты"
      description="Попробуйте еще раз или зайдите позже"
      actions={<Button label="Обновить проекты" onClick={updateProjects} {...buttonProps} />}
    />
  )
}
